import { styled } from 'stitches.config'

export const RecipeRoot = styled('div', {
  width: '100%',
  background: '$accent-white',
  color: '$accent-black',
  '& .m-only': {
    display: 'block',
  },

  '& .d-only': {
    display: 'none',
  },

  '@bp2': {
    '& .m-only': {
      display: 'none',
    },

    '& .d-only': {
      display: 'block',
    },
  },
})

export const BreadCrumbWrapper = styled('div', {
  maxWidth: '500px',
  margin: 'auto',
  padding: '$3 0 $3 $2',
  '@bp2': {
    padding: '$6 0 $6 $1',
    maxWidth: '1292px',
  }
})